import { Alias } from "./Types/Alias";
import { AliasType } from "./Enums/AliasType";
import { PLAYER_LABEL_PROPERTIES } from "./Views/PlayerLabelView";
import { PLAYERGAME_LABEL_PROPERTIES } from "./Views/PlayerGameLabelView";
import { PLAYERSEASON_LABEL_PROPERTIES } from "./Views/PlayerSeasonLabelView";
import { PLAY_LABEL_PROPERTIES } from "./Views/PlayLabelView";
import { GAME_LABEL_PROPERTIES } from "./Views/GameLabelView";
import { SEASON_LABEL_PROPERTIES } from "./Views/SeasonLabelView";
import { COLLEGE_LABEL_PROPERTIES } from "./Views/CollegeLabelView";
import { COLLEGECONFERENCE_LABEL_PROPERTIES } from "./Views/CollegeConferenceLabelView";
import { TEAMGAME_LABEL_PROPERTIES } from "./Views/TeamGameLabelView";

const getPropertiesByType = (aliasType: AliasType): string[] => {
  switch (aliasType) {
    case AliasType.Player:
      return PLAYER_LABEL_PROPERTIES.map((x) => x.key);
    case AliasType.PlayerGame:
      return PLAYERGAME_LABEL_PROPERTIES.map((x) => x.key);
    case AliasType.PlayerSeason:
      return PLAYERSEASON_LABEL_PROPERTIES.map((x) => x.key);
    case AliasType.Play:
      return PLAY_LABEL_PROPERTIES.map((x) => x.key);
    case AliasType.Game:
      return GAME_LABEL_PROPERTIES.map((x) => x.key);
    case AliasType.Season:
      return SEASON_LABEL_PROPERTIES.map((x) => x.key);
    case AliasType.College:
      return COLLEGE_LABEL_PROPERTIES.map((x) => x.key);
    case AliasType.CollegeConference:
      return COLLEGECONFERENCE_LABEL_PROPERTIES.map((x) => x.key);
    case AliasType.TeamGame:
      return TEAMGAME_LABEL_PROPERTIES.map((x) => x.key);
    default:
      return ["*"]; // Fallback for unknown labels
  }
};

// TODO: When multiple aliases of same type exist (e.g., p1, p2 for player comparisons),
// column headers will show duplicate names like "Display Name", "Position" because
// formatColumnHeader() strips the alias prefix. Need to enhance header logic to
// preserve alias context for better UX (e.g., "Player 1: Display Name" vs "Player 2: Display Name")
export const buildSmartReturnClause = (
  aliases: Alias[],
  position: string,
  selectedProperties?: string[],
): string => {
  // If user explicitly selected properties via RETURN chunk, use those
  if (selectedProperties && selectedProperties.length > 0) {
    return `RETURN DISTINCT ${selectedProperties.join(", ")}`;
  }

  // Otherwise, fall back to automatic property selection
  if (aliases.length === 0) {
    return "RETURN *";
  }

  const returnParts: string[] = [];

  // Process each alias individually to support multiples of same type
  aliases.forEach((alias) => {
    const properties = getPropertiesByType(alias.AliasType);

    if (
      properties.length === 0 &&
      alias.AliasType === AliasType.NumberLiteral
    ) {
      // For number literals, return the alias itself (no properties)
      returnParts.push(alias.Name);
    } else if (properties.includes("*")) {
      returnParts.push(`${alias.Name}.*`);
    } else {
      const aliasProps = properties.map((prop) => `${alias.Name}.${prop}`);
      returnParts.push(...aliasProps);
    }
  });

  if (aliases.length === 1) {
    return `RETURN DISTINCT ${returnParts.join(", ")}`;
  }
  return `RETURN ${returnParts.join(", ")}`;
};
